import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'RetailInvest – Ihr Makler für Handelsimmobilien in Deutschland',
  description = 'Professionelle Vermittlung von Handelsimmobilien: Lebensmittelmärkte, Discounter, Fachmärkte, Fachmarktzentren. WAULT-Rechner kostenlos, strukturierter Verkaufsprozess, bundesweit tätig.',
  url = '/',
  image = 'https://investmentlead.preview.emergentagent.com/og-image.jpg',
  type = 'website',
  keywords = 'Handelsimmobilien, Makler, Lebensmittelmärkte, Discounter, Fachmärkte, WAULT, Immobilienbewertung, Verkauf Einzelhandel, RetailInvest',
  author = 'Andreas Heinrichs, Heinrichs Immobilien'
}) => {
  const fullUrl = `https://investmentlead.preview.emergentagent.com${url}`;
  const siteName = 'RetailInvest by Heinrichs Immobilien';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="German" />
      <meta name="revisit-after" content="7 days" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="de_DE" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="geo.region" content="DE" />
      <meta name="geo.placename" content="Freising" />
      <meta name="geo.position" content="48.4010;11.7488" />
      <meta name="ICBM" content="48.4010, 11.7488" />
      
      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#0F2744" />
    </Helmet>
  );
};

export default SEO;
